/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Coinvesttoprimaryratio4Inputs */

const en_coinvestments_insights_col_coinvesttoprimaryratio4 = /** @type {(inputs: Coinvestments_Insights_Col_Coinvesttoprimaryratio4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-invest : primary ratio`)
};

/**
* | output |
* | --- |
* | "Co-invest : primary ratio" |
*
* @param {Coinvestments_Insights_Col_Coinvesttoprimaryratio4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_coinvesttoprimaryratio4 = /** @type {((inputs?: Coinvestments_Insights_Col_Coinvesttoprimaryratio4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Coinvesttoprimaryratio4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_coinvesttoprimaryratio4(inputs)
});
export { coinvestments_insights_col_coinvesttoprimaryratio4 as "coInvestments_insights_col_coinvestToPrimaryRatio" }